import { requesterTypeLabel } from "@/lib/api/admin-access-request-labels";
import {
  portalUserStatusLabel,
  type PortalUserStatus,
} from "@/lib/api/admin-portal-users";
import {
  formatAccessRoleLabel,
  type AccessRole,
} from "@/lib/api/portal-access-role";

export function AdminTypePill({
  type,
}: {
  type: AccessRole | null | undefined;
}) {
  if (!type) {
    return (
      <span className="type-pill type-unset" data-testid="admin-type-pill">
        {formatAccessRoleLabel(type)}
      </span>
    );
  }

  const label = requesterTypeLabel(type);
  const isPartner = type === "partner";
  return (
    <span
      className={`type-pill ${isPartner ? "type-partner" : "type-customer"}`}
      data-testid="admin-type-pill"
    >
      <i
        className={`ti ${isPartner ? "ti-building-skyscraper" : "ti-building"}`}
        aria-hidden="true"
      />
      {label}
    </span>
  );
}

export function PortalUserStatusBadge({ status }: { status: PortalUserStatus }) {
  const cls = status === "verified" ? "s-approved" : "s-review";
  return (
    <span className={`status-badge ${cls}`} data-testid="admin-user-status-badge">
      <span className="s-dot" />
      {portalUserStatusLabel(status)}
    </span>
  );
}
